import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {textMetadata} from '../../../../../utils/builderMetadata'

export type TextsSettingsParams = {
  titleText: SettingsParamType.Text
  allLocationsTabText: SettingsParamType.Text
  reserveNowButtonText: SettingsParamType.Text
  learnMoreButtonText: SettingsParamType.Text
}

export const textsSettingsParams = createSettingsParams<TextsSettingsParams>({
  titleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.experiences-list.title'),
    metadata: textMetadata(
      'uou-reservations.experiences-list.title',
      'Text of the experiences list title',
    ),
  },
  allLocationsTabText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.experiences-list.all-locations-tab'),
    metadata: textMetadata(
      'uou-reservations.experiences-list.all-locations-tab',
      'Label of the location tab that shows experiences from all locations',
    ),
  },
  reserveNowButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.experiences-list.reserve-now-cta'),
    metadata: textMetadata(
      'uou-reservations.experiences-list.reserve-now-cta',
      'Text on the button of experiences that have an online reservation schedule',
    ),
  },
  learnMoreButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.experiences-list.learn-more-cta'),
    metadata: textMetadata(
      'uou-reservations.experiences-list.learn-more-cta',
      'Text on the button of experiences without an online reservation schedule',
    ),
  },
})
